import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { Constants } from '@base/src/app/models/constants'

@Component({
  selector: 'app-rendition-captor-agent-cell',
  templateUrl: './rendition-captor-agent-cell.component.html',
  styleUrls: ['./rendition-captor-agent-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RenditionCaptorAgentCellComponent {
  @Input() agentName: string = ''
  @Input() referredName: string | null = null
  @Input() cobrokers: string[] = []
  // True when the search query matches a co-broker: the pill is replaced by the full co-brokers line
  @Input() expanded: boolean = false

  readonly ICON_COBROKERS = Constants.ICONS.GROUP_OF_PEOPLE

  get hasCobrokers (): boolean {
    return (this.cobrokers?.length ?? 0) > 0
  }

  get cobrokersLabel (): string {
    return this.cobrokers.length === 1 ? 'Co-broker:' : 'Co-brokers:'
  }

  get tooltipText (): string {
    return [this.cobrokersLabel, ...this.cobrokers].join('\n')
  }
}
